import { hover } from 'pobble-components/dist/jss-mixins'

export const buttonStyles = ({ COLORS }) => ({
  button: ({ size }) => ({
    color: COLORS.BLUE.NORMAL,
    cursor: 'pointer',
    fontSize: size(1.6, { scaleFactor: 'sm' }),
    lineHeight: '1',
    userSelect: 'none',
    background: 'none',
    border: 'none',
    padding: '0',
    margin: '0'
  }),
  iconHolder: ({ size }) => ({
    margin: `0 ${size(0.4, { scaleFactor: 'sm' })} 0 0`,
    fontSize: size(1.3, { scaleFactor: 'sm' })
  }),
  title: {
    verticalAlign: 'middle'
  }
})

export const formControlsStyles = ({ COLORS }) => ({
  formContorls: ({ size, printMode }) => ({
    display: printMode ? 'none' : 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: `0 0 ${size(1.6, { scaleFactor: 'sm' })}`
  }),
  button: ({ size }) => ({
    margin: `0 ${size(0.4, { scaleFactor: 'sm' })}`
  }),
  cancelButton: {
    color: COLORS.RED.FADED
  },
  saveButton: {
    color: COLORS.GREEN.NORMAL
  },
  promptsButton: () => ({
    marginRight: '0'
  }),
  separator: ({ size }) => ({
    margin: `0 ${size(0.3)}`,
    width: '1px',
    height: size(1),
    background: COLORS.BLUE.NORMAL
  }),
  pendingNote: ({ size }) => ({
    display: 'block',
    lineHeight: '1',
    fontSize: size(1.6, { scaleFactor: 'sm' }),
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  })
})

export const formHeadStyles = {
  formHead: ({ size }) => ({
    display: 'flex',
    flexDirection: 'row',
    background: '#4A4A4A',
    color: '#fff',
    fontSize: size(2, { scaleFactor: 'lg' }),
    lineHeight: '1',
    fontWeight: 'bold'
  }),
  cell: ({ size }) => ({
    padding: `${size(1.1, { scaleFactor: 'sm' })} 0`,
    border: '1px solid #fff',
    borderLeft: 'none'
  }),
  lastCell: ({ size }) => ({
    borderRight: 'none',
    width: size(4.5, { scaleFactor: 'sm' }),
    textAlign: 'center'
  }),
  firstCell: ({ size }) => ({
    flex: '1',
    padding: `${size(1.1, { scaleFactor: 'sm' })} ${size(1.75, {
      scaleFactor: 'sm'
    })}`
  })
}

export const formRowStyles = ({ COLORS }) => ({
  formRow: ({ size, printMode }) => ({
    display: 'flex',
    flexDirection: 'row',
    fontSize: printMode ? '14px' : size(2, { scaleFactor: 'lg' }),
    lineHeight: '1.2'
  }),
  text: {
    flex: '1',
    '& textarea': {
      '&::placeholder': {
        color: '#BBBBBB'
      }
    }
  },
  cell: ({ size, printMode }) => ({
    width: size(6, { scaleFactor: 'sm' }),
    padding: printMode
      ? '14px'
      : `${size(1.61, { scaleFactor: 'sm' })} ${size(1.75, {
          scaleFactor: 'sm'
        })}`,
    border: '1px solid #4A4A4A',
    borderLeft: 'none',
    margin: '-1px 0 0'
  }),
  lastCell: ({ size }) => ({
    padding: size(1.1, { scaleFactor: 'sm' }),
    width: size(4.5, { scaleFactor: 'sm' })
  }),
  firstCell: {
    borderLeft: '1px solid #4A4A4A !important',
    flex: '1',
    display: 'flex',
    alignItems: 'center'
  },
  criterion: {
    fontWeight: 'bold',
    margin: '0'
  },
  prompts: {
    margin: '0'
  },
  textArea: ({ size }) => ({
    '-webkit-appearance': 'none',
    padding: '0',
    border: 'none',
    background: 'none',
    resize: 'none',
    fontSize: size(2, { scaleFactor: 'lg' }),
    width: '100%',
    display: 'block',
    fontStyle: 'italic'
  }),
  bold: {
    fontWeight: 'bold'
  },
  deleteCell: ({ size }) => ({
    marginLeft: size(1, { scaleFactor: 'sm' })
  }),
  deleteButton: {
    cursor: 'pointer',
    color: COLORS.BLUE.NORMAL,
    ...hover({
      color: COLORS.BLUE.FADED
    })
  },
  sortHandle: ({ size }) => ({
    width: size(1.5, { scaleFactor: 'lg' }),
    height: size(1.5, { scaleFactor: 'lg' })
  }),
  sortCell: ({ size }) => ({
    marginRight: size(1)
  })
})

export default {
  container: {
    flexBasis: '0',
    flexGrow: '1',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  formHolder: {
    flexBasis: '0',
    flexGrow: '1',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  entriesHolder: {
    flexBasis: '0',
    flexGrow: '1',
    overflow: 'hidden',
    position: 'relative'
  },
  entriesContainer: ({ size, printMode }) => ({
    height: '100%',
    overflow: printMode ? 'hidden' : 'auto',
    paddingBottom: size(3, { scaleFactor: 'sm' })
  }),
  fader: ({ size, bgColor, printMode }) => ({
    display: printMode ? 'none' : 'block',
    pointerEvents: 'none',
    position: 'absolute',
    bottom: '0',
    left: '0',
    zIndex: '100',
    width: '100%',
    height: size(5, { scaleFactor: 'sm' }),
    background: `linear-gradient(to top, ${bgColor} 0%,rgba(255,255,255,0) 100%)`
  }),
  sortHelper: ({ bgColor }) => ({
    background: bgColor,
    zIndex: '2000'
  }),
  addLineButton: ({ size }) => ({
    margin: `${size(1.3, { scaleFactor: 'sm' })} 0`
  })
}
